import type moment from 'moment'
import { INTL_DAY_MONTH_NAME_SHORT, INTL_DAY_ONLY } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import { getCurrentIntl } from 'i18n/util/currentIntl'

export default function getCheckInOutText(checkIn?: moment.Moment, checkOut?: moment.Moment) {
  if (checkIn && checkOut) {
    try {
      const intl = getCurrentIntl()
      const startDate = checkIn.month() !== checkOut.month() ?
          intlDateFormatter(checkIn, INTL_DAY_MONTH_NAME_SHORT, intl.locale) :
          intlDateFormatter(checkIn, INTL_DAY_ONLY, intl.locale)
      const endDate = intlDateFormatter(checkOut, INTL_DAY_MONTH_NAME_SHORT, intl.locale)

      return intl.formatMessage(
        {
          id: 'HsvtBc9p-4ktUQ1Exwpe',
          defaultMessage: '{startDate} - {endDate}',
          description: 'Recommendation date range showing the check-in and check-out dates for a hotel',
        },
        {
          startDate,
          endDate,
        },
      )
    } catch {

    }
  }
  return ''
}
